<template>
  <div class="newsPage">
    <div class="top">
        <img src="../img/logo.png" alt="" >
      <div class="line"></div>
      <img src="../img/min_title.png" alt="" class="imgRight">
    </div>
    <div class="main">
      <div class="title">让汉语教学便捷有趣 • 精品教学资源推荐</div>
      <div class="sourceCon">
            <div class="firstLine">
              <img src="../img/sourceimg/cio.png" alt="" class="haveLink" v-on:click="toDetail('http://www.chinesecio.com/')">
              <img src="../img/sourceimg/cti.png" alt="" class="haveLink" v-on:click="toDetail('http://www.chinesetest.cn/index.do')">
            </div>
            <div class="secondLine">
              <img src="../img/sourceimg/greatwall.png" class="haveLink" alt="" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=235&m_lan=1')">
              <img src="../img/sourceimg/clt_guide.png" class="haveLink" alt="" v-on:click="toDetail('http://www.cltguides.com/')">
              <img src="../img/sourceimg/ciic.png" alt="">
              <img src="../img/sourceimg/chineseroad.png">
              <img src="../img/sourceimg/mangamandarin.png" alt="" class="haveLink" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=221&m_lan=1')">
            </div>
            <div class="thirdLine">
              <img src="../img/sourceimg/jingdian.png" class="haveLink" alt="" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=16&m_lan=1')">
               <img src="../img/sourceimg/happychinese.png" alt="" class="haveLink" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=43&m_lan=1')">
              <img src="../img/sourceimg/popon.png" alt="">
              <img src="../img/sourceimg/hanzitiyan.png" alt="">
              <img src="../img/sourceimg/cool_panda.png" class="haveLink" alt="" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=204&m_lan=1')">
              <img src="../img/sourceimg/shengdianwa.png" alt="">
              <img src="../img/sourceimg/dragonicon.png" alt="">
            </div>
            <div class="secondLine">
              <img src="../img/sourceimg/yuketang.png" alt="">
              <img src="../img/sourceimg/alo7.png" alt="">
              <img src="../img/sourceimg/rongbaozhai.png" alt="">
              <img src="../img/sourceimg/yihanyu.png" alt="">
            </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "resource",
  data: function() {
    return {
      
    };
  },
  methods: {
          // 根据图片宽高比动态显示不同样式
    loadImg (dom, i, e) {
        var wrapperWidth = $(dom).width()
        var wrapperHeight = $(dom).height()
        if(e.target.naturalWidth/e.target.naturalHeight - (wrapperWidth/wrapperHeight) > 0){
            this.$set(this.newsList[i], 'toWidth', false)
        $(e.target).css('transform','translateX(-'+(e.target.width-wrapperWidth)/2+'px)')
        }else {
            this.$set(this.newsList[i], 'toWidth', true)
            $(e.target).css('height', 'auto')
            var radio = wrapperWidth/e.target.naturalWidth
            $(e.target).css('transform','translateY(-'+(e.target.height*radio-wrapperHeight)/2+'px)')
        }
    },
    // 跳转
    toDetail(link) {
        window.open(link)
    },
  },
  mounted() {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this compone nt only -->
<style scoped lang="scss">
.newsPage {
  .top {
    margin-left: 55px;
    padding-top: 30px;
    .line {
      display: inline-block;
      width: 1px;
      height: 80px;
      background-color: rgba(255, 255, 255, 0.5);
      margin: 0 45px;
      vertical-align: super;
    }
  }
  .main {
    margin-left: 240px;
    //text-align: right;
    .title {
        font-size: 60px;
        color: #f3bc65;
        font-weight: bold;
        margin: 28px 120px;
    }
    .sourceCon {
         margin: 0 125px 28px;
         width: 1200px;
         height: 550px;
         text-align: center;
         display: inline-block;
         background-image: linear-gradient(140deg, 
		rgba(255, 255, 255, 0.36) 0%, 
		#ffffff 100%), 
        linear-gradient(
            rgba(255, 255, 255, 0.6), 
            rgba(255, 255, 255, 0.6));
        background-blend-mode: normal, 
            normal;
        box-shadow: 0px 5px 10px 0px 
            rgba(0, 0, 0, 0.18);
        border-radius: 30px;
	    border: solid 1px rgba(255, 255, 255, 0.6);
        img {
            vertical-align: top;
        }
        .firstLine {
            margin: 56px 0;
            text-align: center;
            img {
                margin-right:58px;
                cursor: pointer;
            }
        }
        .secondLine {
            img {
                margin: 0 20px;
                
            }
            
        }
        .thirdLine {
            margin: 65px 0;
            img {
                margin: 0 40px;
            }
        }
        .haveLink {
            cursor: pointer;
        }
    }
  }
}
@media screen and (min-width: 1240px) and (max-width: 1280px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        margin-left: 28px;
        .title {
            font-size: 36px;
            margin: 28px 0;
        }
        .sourceCon {
            width: 900px;
            margin: 0 0;
            height: 385px;
            .firstLine {
                margin: 20px 0;
            }
            .secondLine {
                img {
                    transform: scale(0.7);
                    margin: 0;
                }
            }
            .thirdLine {
                margin: 40px 0;
                img {
                    transform: scale(1);
                    margin: 0 20px;
                }
            }
        }
    }
}

  
}
@media screen and (min-width: 1280px) and (max-width: 1600px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        margin-left: 28px;
        .title {
            font-size: 36px;
            margin: 28px 0;
        }
        .sourceCon {
            width: 1065px;
            margin: 0 0;
            height: 485px;
            .firstLine {
                margin: 40px 0;
            }
            .thirdLine {
                margin: 40px 0;
            }
        }
    }
}

  
}


@media screen and (min-width: 1460px) and (max-width: 1680px) {
.newsPage {
    .main {
        float: left;
        text-align: left;
        margin-left: 0;
        .title {
            margin: 28px 60px;
        }
        .sourceCon {
            height: 510px;
           margin: 28px 0 28px 60px;
        }
    }
}

  
}
</style>
